var ovThemeEventHandler = {};

/**
 * @param elementId: Id from the DOM element referencing the element selected
 * @param node: Element to include the Event
 * @param eventType: The type of event (scroll, click, resize...)
 * @param functionHandler: Function to attach inside the listener
 * @param cardListContainer: Element that contains the card list
 * @param capture
 */
function addCustomListener(elementId, node, eventType, functionHandler, cardListContainer = null, capture = false) {
    if (!(elementId in ovThemeEventHandler) || Object.keys(ovThemeEventHandler).length === 0) {
        ovThemeEventHandler[elementId] = []
        pushAndAddNode(elementId, node, eventType, functionHandler, cardListContainer, capture);
    } else {
        var addEvent = true;
        ovThemeEventHandler[elementId].forEach(({handler}) => {
            if (handler.name === functionHandler.name) {
                addEvent = false;
            }
        });
        if (addEvent) pushAndAddNode(elementId, node, eventType, functionHandler, cardListContainer, capture);
    }
}

function pushAndAddNode(elementId, node, eventType, functionHandler, cardListContainer, capture) {
    ovThemeEventHandler[elementId].push({
        eventType: eventType,
        node: node,
        handler: functionHandler,
        capture: capture
    })
    node.addEventListener(eventType, functionHandler, capture);
    console.debug('ACTIVADO el listener ' + functionHandler.name + ' en el elemento ' + elementId);

    deleteListenerWhenElementRemoved(elementId, node, eventType);

    if (cardListContainer) {
        addBackToTop(elementId.concat('_backToTop_buttom'), cardListContainer);
    }
}

function deleteListenerWhenElementRemoved(elementId, targetNode, eventType) {
    var removedElementObserver = new MutationObserver(function (mutationsList) {
        var elementToWatch = document.getElementById(elementId);
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && !elementToWatch) {
                console.debug('DESACTIVADO el listener para el elemento ' + elementId);
                removeCustomListener(elementId, targetNode, eventType)
                removedElementObserver.disconnect();
                break;
            }
        }
    });
    removedElementObserver.observe(document.body, {childList: true, subtree: true});
}

function removeCustomListener(elementId, targetNode, eventType) {
    if (ovThemeEventHandler[elementId]) {
        ovThemeEventHandler[elementId]
            .filter(({node}) => node === targetNode)
            .forEach(({node, handler, capture}) => node.removeEventListener(eventType, handler, capture))

        // update ovThemeEventHandler global
        ovThemeEventHandler[elementId] = ovThemeEventHandler[elementId].filter(
            ({node}) => node !== targetNode)
        if (ovThemeEventHandler[elementId].length === 0) {
            delete ovThemeEventHandler[elementId];
        }
    }
}

function addBackToTop(elementId, cardListContainer) {
    const backToTop_button = document.createElement('div');
    const backButton_icon = document.createElement('i');

    if (!document.getElementById(elementId)) {
        acOvTheme.addClassList(backToTop_button, 'back-to-top hide');
        backToTop_button.id = elementId;
        backToTop_button.setAttribute('data-testid' ,elementId);
        backButton_icon.classList.add('icon-chevron-up');

        backToTop_button.insertAdjacentElement('afterbegin', backButton_icon);
        cardListContainer.insertAdjacentElement('afterend', backToTop_button);

        addCustomListener(elementId, window, 'scroll', function backToTopListener() {
            if (window.scrollY < (cardListContainer.offsetTop + 200) || cardListContainer.childElementCount <= 1) {
                if (!backToTop_button.classList.contains('hide')) {
                    backToTop_button.classList.add('hide');
                }
            } else {
                backToTop_button.classList.remove('hide');
            }
        });

        backToTop_button.addEventListener('click', function () {
            var time = 1000;
            var currentPosition = document.documentElement.scrollTop;
            var distance = cardListContainer.offsetTop - currentPosition;
            var increments = distance / (time / 16);
            var count = 0;

            function animateScroll() {
                count++;
                var newPosition = currentPosition + increments * count;
                window.scrollTo(0, newPosition);
                if (count < time / 16) {
                    requestAnimationFrame(animateScroll);
                }
            }
            animateScroll();
        });
    }
}